import { memo, type SVGProps } from 'react'

const SvgList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.667 8H28m-17.333 8H28m-17.333 8H28M4 8h.013M4 16h.013M4 24h.013"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const Memo = memo(SvgList)
export default Memo
